import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Links } from "@/components/Links";
import { Gallery } from "@/components/Gallery";
import { News } from "@/components/News";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function LandingPage() {
  useLenis();
  return (
    <div className="relative min-h-screen bg-[#0a0a0b] text-white" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <News />
        <Links />
        <Gallery />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
